import { CSAT_RESPONSES_STORAGE_KEY } from './constants'

// Source of truth for the "already responded" gate: a per-user map in localStorage.
// Survives reload and logout, scoped per user so two accounts on one device don't collide.
// All access is wrapped so a disabled/blocked localStorage never throws.

const readStore = () => {
  try {
    const raw = window.localStorage.getItem(CSAT_RESPONSES_STORAGE_KEY)
    return raw ? JSON.parse(raw) : {}
  } catch (error) {
    return {}
  }
}

const writeStore = store => {
  try {
    window.localStorage.setItem(CSAT_RESPONSES_STORAGE_KEY, JSON.stringify(store))
    return true
  } catch (error) {
    return false
  }
}

export const getCsatResponse = userId => {
  if (!userId) return null
  return readStore()[userId] || null
}

export const hasRespondedToCsat = userId => Boolean(getCsatResponse(userId))

// Records (or updates) the user's response. Keeps per-tool history so feedback can be read
// by tool as well as overall. No-ops without a userId to avoid an anonymous shared bucket.
export const recordCsatResponse = (userId, { rating, tool, at }) => {
  if (!userId) return null
  const store = readStore()
  const previous = store[userId] || {}
  const entry = {
    lastRespondedAt: at,
    lastRating: rating,
    lastTool: tool,
    tools: {
      ...(previous.tools || {}),
      [tool]: { at, rating }
    }
  }
  store[userId] = entry
  writeStore(store)
  return entry
}
